import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetMode, setResetMode] = useState(false);
  const [resetMsg, setResetMsg] = useState("");
  const { login, resetPassword } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError("Invalid email or password. Please try again.");
    }
    setLoading(false);
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await resetPassword(email);
      setResetMsg("Password reset email sent! Check your inbox.");
    } catch (err) {
      setError("Could not send reset email. Check the address.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-white flex items-center justify-center px-4" style={{ fontFamily: "Montserrat, sans-serif" }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#e84fa5] rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-white text-2xl font-extrabold">SK</span>
          </div>
          <h1 className="text-2xl font-extrabold text-black">Simple Kindness</h1>
          <p className="text-sm text-gray-400 mt-1">Admin Panel</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h2 className="text-xl font-bold mb-6 text-center">
            {resetMode ? "Reset Password" : "Admin Login"}
          </h2>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-600 text-[13px] px-4 py-3 rounded-lg mb-5">
              {error}
            </div>
          )}
          {resetMsg && (
            <div className="bg-green-50 border border-green-200 text-green-600 text-[13px] px-4 py-3 rounded-lg mb-5">
              {resetMsg}
            </div>
          )}

          <form onSubmit={resetMode ? handleReset : handleLogin} className="space-y-5">
            <div>
              <label className="block text-[12px] font-semibold text-gray-600 mb-1.5">Email Address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full border border-gray-200 rounded-lg px-4 py-3 text-[14px] outline-none focus:border-[#e84fa5] transition"
                placeholder="admin@example.com"
              />
            </div>

            {!resetMode && (
              <div>
                <label className="block text-[12px] font-semibold text-gray-600 mb-1.5">Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full border border-gray-200 rounded-lg px-4 py-3 text-[14px] outline-none focus:border-[#e84fa5] transition"
                  placeholder="••••••••"
                />
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3.5 bg-[#e84fa5] text-white font-bold uppercase text-[13px] rounded-lg hover:bg-pink-600 transition disabled:opacity-60"
            >
              {loading ? "Please wait..." : resetMode ? "Send Reset Email" : "Login"}
            </button>
          </form>

          <button
            onClick={() => { setResetMode(!resetMode); setError(""); setResetMsg(""); }}
            className="w-full mt-4 text-center text-[12px] text-gray-500 hover:text-[#e84fa5] transition"
          >
            {resetMode ? "← Back to Login" : "Forgot Password?"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
